<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      :show-save-button="editType !== 2"
      unit="需求单"
      edit-title
      id-key="UserId"
      :data="data"
      :save-func="api.save"
      :line-form="true"
      :form-rules="rules"
      form-label-width="100px"
      :before-save="onBeforeSave"
      @opened="onOpened"
      @details-opened="onDetailsOpened"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="8">
              <el-form-item label="单据时间" prop="DocDate">
                <el-date-picker
                  v-if="editType !== 2"
                  v-model="data.DocDate"
                  type="date"
                  placeholder="请输入单据时间"
                  @change="previewNo"
                >
                </el-date-picker>
                <span v-else>{{data.DocDate}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单据编码:" prop="DocNo">
                <span v-if="Mode == 0 || isDetails" class="not-edit">{{
                  data.DocNo
                }}</span>
                <el-input
                  v-else
                  v-model="data.DocNo"
                  placeholder="请输入单据编码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="创建人" prop="MakeEmpId">
                <span>{{ data.MakeEmpName }}</span>
                <!-- <select-input
                  placeholder="请选择创建人"
                  :label="data.MakeEmpName"
                  v-model="data.MakeEmpId"
                  @click="openEmp"
                  style="width: 190px"
                /> -->
                <!-- <el-input
                  clearable
                  v-model="data.MakeEmpId"
                  placeholder="请输入创建人"
                /> -->
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>

        <el-table row-key="demand" ref="list" :data="tableData">
          <el-table-column
            prop="TradeUnitName"
            label="建议供应商"
            min-width="140"
            align="center"
          >
            <template slot-scope="{ row, $index }">
              <el-link type="primary" @click="_edit(row, $index)">{{
                row.TradeUnitName
              }}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="ProductNo"
            label="存货编码"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="ProductName"
            label="存货名称"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="ProductSpec"
            label="规格"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="ColorName"
            label="颜色"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="PropertyName"
            label="属性"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="ActualQuantity"
            label="加工单生产数量"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="PurchaseQuantity"
            label="采购量"
            min-width="120"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-input
                type="number"
                v-model.number="row.PurchaseQuantity"
                placeholder="请输入采购数量"
                v-if="editType !== 2"
                @input="changT(row)"
              ></el-input>
              <span v-else>{{row.PurchaseQuantity}}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </common-dialog>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <suppliers-dialog
      ref="suppliersDialog"
      @setData="setTrad"
      :status="editType !== 2"
    ></suppliers-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import suppliersDialog from "./suppliersDialog";
import empDialog from "@/components/personnel/result/record/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    suppliersDialog,
    empDialog,
  },
  props: {
    isCreate: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      api: require("@/api/pu/puPurchaseDemand").default,
      code_api: require("@/api/sy/serialCode").default,
      rules: {
        DocDate: [{ required: true, message: "单据时间不能为空" }],
        DocNo: [{ required: true, message: "单据编码不能为空" }],
        MakeEmpId: [{ required: true, message: "创建人不能为空" }],
      },
      Mode: 0,
      data: {
        PurchaseDemandId: 0,
        DocNo: "",
        DocDate: this.$commonJs.getToday(),
        Status: 0,
        MakeEmpId: 0,
        MakeEmpName: "",
        MakeDate: "",
        ReviewEmpId: 0,
        ReviewDate: "",
        UpdateEmpId: 0,
        UpdateDate: "",
        AddTime: "",
        TradeUnitName: "",
        DetailModels: [],
      },
      copyTableData: [],
      tableData: [],
      editType: 0,
    };
  },
  created() {},
  methods: {
    changT(row){
      if(row.T == null ) row.T = 1;
    },
    previewNo() {
      this.code_api.previewNo("采购需求单", this.data.DocDate).then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取采购需求单编号失败");
        }
      });
    },
    onOpened() {
      console.log('this.isCreate', this.isCreate)
      if(this.isCreate){
        this.previewNo();
     
        const user = this.$store.state.user;
        if (user) {
          this.data.MakeEmpId = user.empId;
          this.data.MakeEmpName = user.name;
        }
      }
      
    },
    onCreateOpened(item) {
      console.log("data", item);
      var tradeUnitModels = [];
      this.editType = 0;
      // 获取加工列表数据
      this.tableData = item.reduce((acc, item) => {
        if(item.DefaultSupplier > 0){
          tradeUnitModels.push({
            PurchaseDemandTradeUnitId: 0,
            PurchaseQuantity: 0,
            ShortName: "",
            T: 0,
            TradeUnitId: item.DefaultSupplier,
            TradeUnitName: item.SupplierName,
            TradeUnitNo: item.SupplierNo,
            index: 0
          })
        }

        return acc.concat({
          T: 0,
          TradeUnitModels: tradeUnitModels,

          // PurchaseDemandId: 0,
          WorkDocId: 0,
          WorkDocProductId: 0,
          ProductId: 0,
          ProQuantity: 0,
          PurchaseQuantity: 0,

          SafetyStock: 0,
          ColorId: 0,
          ColorName: "",
          PuUnitName: "",
          TradeUnitFullName: "",
          WarehouseName: "",
          DocNo: "",
          DocDate: "",
          ReviewEmpId: 0,
          MakeEmpId: 0,
          MakeEmpName: "",
          ReviewEmpName: "",
          UpdateEmpName: "",
          UpdateEmpId: 0,
          WorkDocNo: "string",
          ExecutionQuantity: 0,
          ExecutionQuantity2: 0,
          Status: 0,
          ...item,
          PurchaseDemandDetailId: 0,
          TradeUnitId: item.DefaultSupplier,
          TradeUnitName: item.SupplierName ? item.SupplierName + `(${item.SupplierNo})` : "请选择供应商"
        });
      }, []);
      this.copyTableData = JSON.parse(JSON.stringify(this.tableData))
      console.log('this.copyTableData', this.copyTableData)
      //相同存货Id，且相同供应商，合并起来，生产数量相加
      const arr = this.tableData.map((item, index) => {
        const minIndex = this.tableData.findIndex(el => el.ProductNo == item.ProductNo && el.DefaultSupplier == item.DefaultSupplier);
        if (index > minIndex) {
          this.tableData[index].ActualQuantity = parseFloat(this.tableData[index].ActualQuantity.toFixed(2))
          this.tableData[minIndex].ActualQuantity += this.tableData[index].ActualQuantity;
          return;
        }
        return item;
      })
      this.tableData = arr.filter(item => item);
      this.tableData.forEach(item => {
        item.ActualQuantity = parseFloat(item.ActualQuantity.toFixed(2))
        item.PurchaseQuantity = item.ActualQuantity;
        if(item.TradeUnitModels.length > 0){
          item.TradeUnitModels[0].PurchaseQuantity = item.PurchaseQuantity;
        }
      })
      console.log("tableData", this.tableData);
      // this.api.info(data.PurchaseDemandId).then((res) => {
      //   if (res.Code === 0) {
      //     this.data = res.Data;
      //     this.tableData = res.Data.DetailModels;
      //   }
      // });
    },
    onEditOpened(data) {
      this.editType = 1;
      console.log("data edit", data);
      this.api.info(data.PurchaseDemandId).then((res) => {
        if (res.Code === 0) {
          this.data = res.Data;

          this.copyTableData = JSON.parse(JSON.stringify(res.Data.DetailModels))

          
          
          this.tableData = res.Data.DetailModels.reduce((acc,item)=>{
                item.T = null;
                item.TradeUnitName = item.TradeUnitModels.map(i=>(i.T =null,i.TradeUnitName + `(${i.TradeUnitNo})`)).join();
                if (!item.TradeUnitName) item.TradeUnitName = "请选择供应商";
                acc.push(item)
                return acc
          },[]);

          this.tableData.forEach(item => {
            item.ActualQuantity = item.ProQuantity;
          })

          const arr = this.tableData.map((item, index) => {
          const minIndex = this.tableData.findIndex(el => el.ProductNo == item.ProductNo);
            if (index > minIndex) {
              this.tableData[index].ActualQuantity = parseFloat(this.tableData[index].ActualQuantity.toFixed(2))
              this.tableData[minIndex].ActualQuantity += this.tableData[index].ActualQuantity;
              return;
            }
            return item;
          })
          this.tableData = arr.filter(item => item);
          this.tableData.forEach(item => {
            item.ActualQuantity = parseFloat(item.ActualQuantity.toFixed(2))
            item.PurchaseQuantity = item.ActualQuantity;
          })
          // console.log('tableData',this.tableData);
        }
      });
    },
    onDetailsOpened(data) {
      this.editType = 2;
      console.log("data", data);
      this.api.info(data.PurchaseDemandId).then((res) => {
        if (res.Code === 0) {
          this.data = res.Data;

          
          this.tableData = res.Data.DetailModels.reduce((acc,item)=>{
                item.T = null;
                item.TradeUnitName = item.TradeUnitModels.map(i=>(i.T =null,i.TradeUnitName + `(${i.TradeUnitNo})`)).join();
                acc.push(item)
                return acc
          },[]);

          this.tableData.forEach(item => {
            item.ActualQuantity = item.ProQuantity;
            item.ActualQuantity = parseFloat(item.ActualQuantity.toFixed(2))
          })
          // console.log('tableData',this.tableData);
        }
      });
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      console.log(data);
      this.data.MakeEmpId = data.EmpId;
      this.data.MakeEmpName = data.EmpName;
      // this.data.DpId = data.DpId;
      // this.data.DpName = data.DpName;
      // this.data.DpNo = data.DpNo;
    },
    setTrad(res) {
      console.log("res", res);
      console.log('this.tableData', this.tableData)
      if (res.Data?.length > 0) {
        const title = res.Data?.map((i) => i.TradeUnitName + `(${i.TradeUnitNo})`).join();
        let sum = res.Data?.map((i) => i.PurchaseQuantity).reduce((prev, curr) => {
          return prev + curr;
        })
        this.tableData[res.index].PurchaseQuantity = parseFloat(sum.toFixed(2));
        this.tableData[res.index].TradeUnitName = title;

        let tableData = JSON.parse(JSON.stringify(this.tableData))
        this.tableData = [];
        this.tableData = tableData;
        // console.log('this.tableData[res.index]',this.tableData[res.index] )
      } else {
        this.tableData[res.index].TradeUnitName = "请选择供应商";
      }

      this.tableData[res.index].TradeUnitModels = res.Data;
    },
    onBeforeSave() {
      this.tableData.forEach(item => {
        item.TradeUnitModels = item.TradeUnitModels.filter(v => {
          return v.T != null
        })

        if(item.TradeUnitModels.length > 0 && item.T !== 0){
          item.T = 1
        }
      })

      this.tableData = this.tableData.filter(item => {
        return item.T != null
      })

      this.tableData.forEach(item => {
        item.ProQuantity = item.ActualQuantity
      })


      console.log('this.tableData', this.tableData)
      console.log('this.copyTableData', this.copyTableData)

      let arr = [];
      
      let copyTableData = this.copyTableData.sort((a, b) => a.WorkDocId - b.WorkDocId);
      console.log('copyTableDatacopyTableData', copyTableData)


      this.tableData.forEach(item => {
        let sum = item.PurchaseQuantity;
        let temps = copyTableData.filter(v => {
          return item.ProductId === v.ProductId
        })

        let length = temps.length;
        if(length > 1){
          for(let i = 0; i < length; ++i){
            let lastSum = sum;
            sum = sum - temps[i].ActualQuantity;

            if(sum >= 0){
              let o = {
                ...item,
                PurchaseQuantity: temps[i].ActualQuantity,
                ActualQuantity: temps[i].ActualQuantity,
                ProQuantity: temps[i].ActualQuantity,
                WorkDocId: temps[i].WorkDocId,
                WorkDocProductId: temps[i].WorkDocProductId,
              }
              arr.push(o)
            }else{
              if(lastSum > 0){
                let o = {
                  ...item,
                  PurchaseQuantity: lastSum,
                  ActualQuantity: temps[i].ActualQuantity,
                  WorkDocId: temps[i].WorkDocId,
                  ProQuantity: temps[i].ActualQuantity,
                  WorkDocProductId: temps[i].WorkDocProductId,
                }
                arr.push(o)
              }else{
                if(item.PurchaseDemandId != null && item.PurchaseDemandId > 0){
                  let o = {
                    ...item,
                    T: 2,
                    WorkDocId: temps[i].WorkDocId,
                    WorkDocProductId: temps[i].WorkDocProductId,
                  }
                  arr.push(o)
                }
              }
            }
            
          }
        }else{
          arr.push(item)
        }
      })


      this.data.DetailModels = arr;

      console.log('this.data.DetailModels', this.data.DetailModels)

    },
    _edit(row, index) {
      row.index = index;
      this.$refs.suppliersDialog.open(row);
    },
    // _getData(data) {
    //   this.api.list({ids}).then(res => {
    //     let data = res.Data;
    //     data.forEach(item => {
    //       let str = '';
    //       let length = item.suppliers.length
    //       item.suppliers.forEach((v, i) => {
    //         if(i === length - 1){
    //           str += v.suppliersName
    //         }else{
    //           str += v.suppliersName + ','
    //         }
    //       })
    //       item.suppliersText = str;
    //     })
    //     this.tableData = data;
    //   })
    // },
    // _getDataInfo(ids) {
    //   this.api.info({ ids }).then((res) => {
    //     let data = res.Data;

    //     data.forEach((item) => {
    //       let str = "";
    //       let length = item.suppliers.length;
    //       item.suppliers.forEach((v, i) => {
    //         if (i === length - 1) {
    //           str += v.suppliersName;
    //         } else {
    //           str += v.suppliersName + ",";
    //         }
    //       });
    //       item.suppliersText = str;
    //     });
    //     this.tableData = data;
    //   });
    // },
  },
};
</script>
